<template lang="pug">
header.header(:class='{"header__fix": show}')
  img.logo_header.pc(src='../static/KV_v8_logo_sbereapteka.svg')
  .header__burger.mobile(@click='show = !show' :class='{burger_active: show}')
    <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect class='header__burger1' width="30" height="2" fill="white"/>
      <rect class='header__burger2' y="18" width="30" height="2" fill="white"/>
      <rect class='header__burger3' y="9" width="30" height="2" fill="white"/>
    </svg>
  nav.header__nav.pc
    a.header__nav-link(v-for="item in links" :key="item.name" :href='"#" +  item.link') {{item.name}}
  nav.header__nav.mobile(v-show="show" :class='{header__nav_active: show}')
    a.header__nav-link(v-for="item in links" :key="item.name" :href='"#" +  item.link' @click='show = false') {{item.name}}
    img(src='../static/connections.png')

</template>

<script>
export default {
  name: 'theHeader',
  data() {
    return {
      show: false,
      links: [
        {
          name: 'LIVE-ТРАНСЛЯЦИЯ',
          link: 'live',
        },
        {
          name: 'МЕРОПРИЯТИЕ',
          link: 'event',
        },
        {
          name: 'SMART TV',
          link: 'smart',
        },
        {
          name: 'ZOOM',
          link: 'zoom',
        },
        {
          name: 'АКТИВНОСТИ',
          link: 'activity',
        },
      ],
    };
  },
};
</script>

<style lang="sass">
.header
  position: absolute
  left: 0
  top: 0
  right: 0
  padding: 52px 66px
  display: flex
  border-bottom: 1px solid rgba(255, 255, 255, 0.1)
  z-index: 5000
  align-items: center
  justify-content: space-between
  @media screen and (max-width: 812px)
    border: 0
    padding: 12px 20px
  &__fix
    position: fixed
  &__nav
    display: flex
    width: 100%
    @media screen and (max-width: 812px)
      position: fixed
      top: 0
      bottom: 0
      right: 0
      left: 0
      width: auto
      height: 100vh
      flex-direction: column
      align-items: center
      justify-content: center
      background: linear-gradient(201.53deg, #40C8C4 0%, #603A8E 99.99%)
      img
        opacity: 0.4
        position: absolute
        bottom: 0
        right: 0
        width: 170px;
        height: 160px;
    &_active
      img
        animation: nav forwards 1s
      @keyframes nav
        0%
          transform: translateY(100%)
        100%
          transform: translateY(0%)
    &-link
      font-size: 14px
      line-height: 16px
      letter-spacing: 3px
      color: #FFFFFF
      text-decoration: none
      @media screen and (max-width: 812px)
        font-size: 20px;
        line-height: 23px;
        text-align: center;
      &:first-child
        margin-right: auto !important
        @media screen and (max-width: 812px)
          margin-right: 0 !important
      &:not(:last-child)
        margin-bottom: 36px
        @media screen and (min-width: 813px)
          margin-bottom: 0
          margin-right: 30px
  &__burger
    position: relative
    z-index: 5
    margin-left: auto
    rect
      transition: 0.3s
.burger_active
  .header__burger1
    transform: rotate(45deg)
  .header__burger3
    transform: translateX(-100px)
  .header__burger2
    transform: rotate(-45deg) translate(-18px, -5px)
.logo
  &_header
    margin-right: 119px
</style>
